export default __webpack_public_path__ + "static/media/partner-wsg-swarovski.cca0f589.jpg";